import { fetchSingleDevice } from 'Services/ServiceProviderManagement/Features/Device/deviceSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { useEffect } from 'react'

function useSingleDevice(id: string | undefined) {
  const dispatch = useAppDispatch()
  const { singleDevice, singleLoading, submitLoading } = useTypedSelector(state => state.device)

  useEffect(() => {
    if (!id) return
    dispatch(fetchSingleDevice({ id }))
  }, [id])

  return {
    singleDevice,
    singleLoading,
    submitLoading
  }
}

export default useSingleDevice
